<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
    width="800px"
    class="dialog_center_type files_dialog"
    :title="$t('message.DataRegistration.International.confirm_title')"
  >
    <el-row :gutter="48">
      <!-- 本次申請國際駕照有效期至 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{
            $t(
              "message.DataRegistration.International.internationalLicenseExpiredDate"
            )
          }}
        </div>
        <el-input class="form_value" v-model="application.internationalLicenseExpiredDate" disabled></el-input>
      </el-col>
      <!-- 國際駕照領證地點 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{
            $t("message.DataRegistration.International.internationalAddress")
          }}
        </div>
        <el-select class="form_value" v-model="application.addresses" placeholder="" disabled>
          <el-option v-for="(item,i) in addresses" :key="i" :value="item.code" :label="item[`name${$t('message.lans')}`]"></el-option>
        </el-select>
      </el-col>
      <!-- 聯絡電話 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("message.DataRegistration.International.mobile") }}
        </div>
        <el-input class="form_value" v-model="application.macauMobile" disabled></el-input>
      </el-col>
      <!-- 語言偏好 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("message.DataRegistration.International.language") }}
        </div>
        <el-select class="form_value" v-model="application.language" placeholder="" disabled>
          <el-option v-for="(item,i) in language" :key="i" :value="item.code" :label="item.label"></el-option>
        </el-select>
      </el-col>
      <!-- 電子郵件 -->
      <el-col :xs="24" :sm="24">
        <div class="form_label">
          {{ $t("message.DataRegistration.International.email") }}
        </div>
        <el-input class="form_value" v-model="application.email" disabled></el-input>
      </el-col>
      <!-- 提示 -->
      <el-col :xs="24" :sm="24">
        <div class="form_tips_title">{{$t('message.DataRegistration.International.notice')}}</div>
        <div class="form_tips_value">
          {{
            $t("message.DataRegistration.International.question1", [
              language.filter((ele) => ele.code === $t("message.lang"))[0]
                .label,
            ])
          }}
        </div>
        <div v-if="showDiffTips" class="form_tips_value">
          {{
            $t("message.DataRegistration.International.device_deff_tips", [
              String(application.cert.macauMoblie).slice(0, 4 * -1) +
                "****",
              application.cert[`lanauage${$t("message.lans")}`],
            ])
          }}
        </div>
        <div v-if="!showDiffTips" class="form_tips_value">
          {{ $t("message.DataRegistration.International.question2_text") }}
        </div>
      </el-col>
      <!-- 一吋半彩色（白色背景）近照 -->
      <el-col :xs="24" :sm="24">
        <div v-if="documentType.length > 0" class="form_label">
          {{ documentType[0][`name${$t("message.lan")}`] }}
        </div>
        <el-row :gutter="48">
          <el-col :xs="24" :sm="12">
            <div v-if="documentType.length > 0" class="form_value">
              <div class="upload_list_file">
                <img
                  v-if="documentType[0].uploadFile"
                  :src="createdUrl(documentType[0].uploadFile)"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 澳門駕駛執照 -->
      <el-col :xs="24" :sm="24">
        <div v-if="documentType.length > 1" class="form_label">
          {{ documentType[1][`name${$t("message.lan")}`] }}
        </div>
        <el-row :gutter="48">
          <el-col :xs="24" :sm="12">
            <div v-if="documentType.length > 1" class="form_value">
              <span>{{ $t("message.frontSide") }}</span>
              <div class="upload_type2_file">
                <img
                  v-if="documentType[1].uploadFile"
                  :src="createdUrl(documentType[1].uploadFile)"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div v-if="documentType.length > 2" class="form_value">
              <span>{{ $t("message.reverseSide") }}</span>
              <div class="upload_type2_file">
                <img
                  v-if="documentType[2].uploadFile"
                  :src="createdUrl(documentType[2].uploadFile)"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 身份證明文件 -->
      <el-col :xs="24" :sm="24">
        <div v-if="documentType.length > 1" class="form_label">
          {{ documentType[3][`name${$t("message.lan")}`] }}
        </div>
        <el-row :gutter="48">
          <el-col :xs="24" :sm="12">
            <div v-if="documentType.length > 3" class="form_value">
              <span>{{ $t("message.frontSide") }}</span>
              <div class="upload_type2_file">
                <img
                  v-if="documentType[3].uploadFile"
                  :src="createdUrl(documentType[3].uploadFile)"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div v-if="documentType.length > 4" class="form_value">
              <span>{{ $t("message.reverseSide") }}</span>
              <div class="upload_type2_file">
                <img
                  v-if="documentType[4].uploadFile"
                  :src="createdUrl(documentType[4].uploadFile)"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-row :gutter="32">
        <el-col :xs="24" :md="12" style="margin-bottom: 10px">
          <GradientBtn @click="$emit('close')">{{
            $t("message.back")
          }}</GradientBtn>
        </el-col>
        <el-col :xs="24" :md="12" style="margin-bottom: 10px">
          <GradientBtn @click="$emit('next')">
            {{ $t("message.DataRegistration.International.next_pay") }}
          </GradientBtn>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import ServiceTypeConfigAPI from "../../../../api/ServiceTypeConfigAPI";
import GradientBtn from "../../../../components/GradientBtn";
export default {
  props: ["application", "documentType", "submitLoading", "showDiffTips"],
  components: { GradientBtn },
  data() {
    return {
      statusType: [],
      language: [
        { code: "ZH_HANT", label: "中文繁體" },
        { code: "ZH_HANS", label: "中文简体" },
        { code: "EN", label: "English" },
        { code: "PT", label: "Português" },
      ],
    };
  },
  computed: {
    addresses(){
      const application = this.application;
      return application.addresses && [application.addresses]
    }
  },
  methods: {
    createdUrl(blob) {
      return URL.createObjectURL(blob);
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        //   readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("file-error"));
        };
      });
    },
    // 獲取領證地點
    getZones() {
      this.loading = true;
      ServiceTypeConfigAPI.getZones("DRV_LIC_INTER")
        .then((res) => {
          this.loading = false;
          this.statusType = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    // const documentType = JSON.parse(JSON.stringify(this.documentType));
    // this.mDocumentType = documentType.map((ele) => {
    //   if (ele.uploadFile) {
    //     console.log(URL.createObjectURL(ele.uploadFile));
    //     ele.uploadFile = URL.createObjectURL(ele.uploadFile);
    //   }
    //   return ele;
    // });
  },
};
</script>

<style lang="scss" scoped>
.upload_list_file {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background: #f2f2f2;
  padding: 10px;
  border-radius: 10px;
  max-width: 200px;
  margin: 20px 0;
}
.upload_type2_file {
  border-radius: 10px;
  border: 1px solid #d7d7d7;
  text-align: center;
  overflow: hidden;
  .avatar-uploader {
    height: 209px;
  }
  /deep/.el-upload,
  .avatar-uploader-icon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
  }
  .avatar {
    width: auto;
    height: auto;
    max-width: 100%;
    // max-height: 170px;
    margin: auto;
  }
}
.form_value{
  width: 100%;
}
.form_tips_title{
  color: #8c8c8c;
  font-size: 16px;
  font-weight: 500;
  color: #5ba7ad;
  line-height: 22px;
  margin-bottom: 11px;
}
.form_tips_value{
  font-size: 16px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
  line-height: 22px;
  margin-bottom: 12px;
  min-height: 22px;
}
.form_tips_value::before{
  content: "-";
}
</style>